import { HelpMenuItemsSlotPlacement as BasicHelpMenuItemsSlotPlacement } from '@wix/extensions-slots-host';
import { withEditorSlotsState } from '../withEditorSlotsState';

export const HelpMenuItemsSlotPlacement = withEditorSlotsState(
  BasicHelpMenuItemsSlotPlacement,
);
